//
// These are global constants shared by actions
//

// User has logged out
export const LOGOUT = 'tokenized/global/LOGOUT';
